import { getSpinWheelItems } from '../../API/api';
import { normalizeSpinWheelItems } from './spinWheelItems';

const readResponseJson = async (response) => {
  const responseText = typeof response?.text === 'function' ? await response.text() : '';

  if (!responseText.trim()) {
    return [];
  }

  return JSON.parse(responseText);
};

export const loadSpinWheelItems = async () => {
  const response = await getSpinWheelItems();

  if (!response?.ok) {
    throw new Error(`Fetching spin wheel items failed with ${response?.status || 'unknown'} status`);
  }

  return normalizeSpinWheelItems(await readResponseJson(response));
};
